export const PREVIEW_HEIGHT = 160;

export interface Size {
  width: number;
  height: number;
}

// The image's box when fitted into the preview, and the page frame's crop inside that box.
// A `cover` crop only has slack along one axis, and object-position % maps onto that slack.
export function cropGeometry(natural: Size, previewWidth: number, frameAspect: number) {
  const scale = Math.min(previewWidth / natural.width, PREVIEW_HEIGHT / natural.height);
  const image = { width: natural.width * scale, height: natural.height * scale };
  const wide = image.width / image.height > frameAspect;
  const crop = wide
    ? { width: image.height * frameAspect, height: image.height }
    : { width: image.width, height: image.width / frameAspect };

  return {
    image,
    crop,
    axis: wide ? ('x' as const) : ('y' as const),
    slack: wide ? image.width - crop.width : image.height - crop.height,
  };
}
